import {
  TAYSPOLKU_PAGE_NOTIFICATION,
  TAYSPOLKU_SERVICES_NOTIFICATION,
} from '../../../definitions/NotificationConstants';
import { BACKENDNOTIFICATIONS } from '../../reducer';
import {
  notificationIsFetching,
  notificationShouldBeVisible,
} from '../selector';
import { doRequestDismissNotifications } from '../../notification/actions';
import Logger from '../../../utils/Logger';

const createActionName =
  require('../../util').createActionName('services/taysPolku');

let { id: module_id } = module;
const logger = new Logger(module_id);

export const TAYS_POLKU_REDIRECT_URL_RECEIVE = createActionName(
  'TAYS_POLKU_REDIRECT_URL_RECEIVE'
);
export const TAYS_POLKU_REDIRECT_URL_REQUEST = createActionName(
  'TAYS_POLKU_REDIRECT_URL_REQUEST'
);
export const TAYS_POLKU_REDIRECT_URL_ERROR = createActionName(
  'TAYS_POLKU_REDIRECT_URL_ERROR'
);

export const requestRedirectUrl = () => ({
  type: TAYS_POLKU_REDIRECT_URL_REQUEST,
});

export const receiveRedirectUrl = (data) => ({
  type: TAYS_POLKU_REDIRECT_URL_RECEIVE,
  payload: data,
});

export const redirectUrlError = (data) => ({
  type: TAYS_POLKU_REDIRECT_URL_ERROR,
  payload: data,
});

export const doRedirect = () => (dispatch, getState, services) => {
  dispatch(requestRedirectUrl());

  return services.api
    .taysPolkuRedirect()
    .then((data) => {
      return dispatch(receiveRedirectUrl(data));
    })
    .catch((err) => {
      dispatch(redirectUrlError(err));
    });
};

export const automaticallyDismissTaysPolkuActivationNotification =
  () => (dispatch, getState) => {
    let state = getState();
    let { data: notificationData } = state[BACKENDNOTIFICATIONS];

    if (
      notificationShouldBeVisible(TAYSPOLKU_SERVICES_NOTIFICATION)(
        notificationData
      ) &&
      !notificationIsFetching(TAYSPOLKU_PAGE_NOTIFICATION)(notificationData)
    ) {
      logger.debug('dispatching dismiss service activation notification');
      dispatch(
        doRequestDismissNotifications([TAYSPOLKU_SERVICES_NOTIFICATION])
      );
    }
  };
